// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"483":"348d409e","787":"4e6ee76c"}[chunkId] + ".chunk.js";
};